import { assertNever } from '@kofno/piper';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../EmptyFragment';
import ParticipantsV2Store from '../Store';
import Pages from './Pages';
import Summary from './Summary';

interface Props {
  store: ParticipantsV2Store;
}

function Pagination({ store }: Props) {
  switch (store.state.kind) {
    case 'loading':
    case 'error':
      return emptyFragment();
    case 'ready': {
      const { metadata, payload } = store.state.resource;
      return payload.participants.length > 0 ? (
        <div className="mt-6 flex flex-wrap items-center justify-between gap-4">
          <Summary metadata={metadata} shown={payload.participants.length} />
          <Pages store={store} metadata={metadata} />
        </div>
      ) : (
        emptyFragment()
      );
    }
    default:
      return assertNever(store.state);
  }
}

export default observer(Pagination);
